import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'aum-cli-twofa-reminder-dialog',
  templateUrl: './twofa-reminder-dialog.component.html',
  styleUrls: ['./twofa-reminder-dialog.component.scss']
})
export class TwofaReminderDialogComponent {
  constructor(private ref: MatDialogRef<TwofaReminderDialogComponent>) {}
  activate() {
    this.ref.close('activate');
  }
  dismiss() {
    this.ref.close('dismiss');
  }
}
